/* unplugin-vue-components disabled */import { render } from "./tiaoma.vue?vue&type=template&id=20786a03&scoped=true"
import script from "./tiaoma.vue?vue&type=script&lang=js"
export * from "./tiaoma.vue?vue&type=script&lang=js"

import "./tiaoma.vue?vue&type=style&index=0&id=20786a03&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20786a03"]])

export default __exports__